import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { cache } from '@customerio/hydra-nav-state';
import { useAnalytics } from '@/services/analytics';

const actionEventMap = {
  create: 'routineToolCreated',
  update: 'routineToolUpdated',
  delete: 'routineToolDeleted',
  run: 'routineToolRun',
  list: 'routineToolListed',
  history: 'routineToolHistory',
} as const;

export function CronTool() {
  const { track } = useAnalytics();

  useCopilotTool({
    type: 'server',
    name: 'cron',
    handler({ response, args }) {
      if (response?.error != null) return;
      cache.invalidate({ type: 'all' });

      const action = typeof args?.action === 'string' ? args.action : '';
      const eventName = actionEventMap[action as keyof typeof actionEventMap];
      if (eventName != null) {
        const routineName = typeof args?.name === 'string' ? args.name : '';
        track('aiAssistant', eventName, {
          Action: action,
          'Routine Name': routineName,
        });
      }
    },
  });

  return null;
}
